export const CHARACTERS = 8

export const RULES = [
  {
    rule: 'At least one number',
    isValid: false,
  },
  {
    rule: `${CHARACTERS} or more characters`,
    isValid: false,
  },
]
